import { List, Map, OrderedMap, OrderedSet, Set } from 'immutable';

export const TRUE = 'true';

export const FALSE = 'false';

export const SEARCH_DEBOUNCE_TIMEOUT = 500;

export const NONE = 'None';

export const VELA = 'vela';

export const SEPARATOR = {
  COLON: ':',
  COMMA: ',',
  COMMA_SPACE: ', ',
  DASH: '—',
  DOT: '.',
  NEW_LINE: '\n',
  HYPHEN: '-',
  HYPHEN_SPACE: ' - ',
  SLASH: '/',
  SLASH_SPACE: ' / ',
  SPACE: ' ',
  UNDERSCORE: '_',
  VERTICAL_BAR: '|',
  VERTICAL_BAR_SPACE: ' | ',
};

export const EMPTY = {
  LIST: List(),
  MAP: Map(),
  ORDERED_MAP: OrderedMap(),
  ORDERED_SET: OrderedSet(),
  SET: Set(),
};

export const INPUT = {
  EMAIL: 'email',
  PASSWORD: 'password',
  NUMBER: 'number',
  RANGE: 'range',
  SUBMIT: 'submit',
  TEXT: 'text',
};

export const NUMBER_INPUT = {
  CENTS: 'cents',
  FONT_SIZE: 'font_size',
  FRACTION: 'fraction',
};
